module.exports = __webpack_public_path__ + "static/Fan Wear Screen-04f147248115d729692ef80573b65154.png";